import { h, Host } from "@stencil/core";
export class InfoBanner {
    constructor() {
        this.type = "info";
        this.icon = undefined;
    }
    render() {
        return (h(Host, { key: 'b0548acc49ea8ce3d997a7434e25cf55641153b5', class: {
                [`ux-info-banner--type-${this.type}`]: true
            } }, h("span", { key: 'd611b2f5bf13fdcdb4b468370f69c6d3e732ce2a', class: {
                ["ux-info-banner__icon"]: true,
                [`ux-info-banner__icon--type-${this.type}`]: true
            } }, h("ux-icon", { key: 'a7c924fca35a483741c606af42dc1d2b5ec73369', name: this.icon, weight: "medium", "size-s": 25 })), h("div", { key: '37cdfccbc3a2a9539e863029ff5e8b3a13705a4f', class: "ux-info-banner__message ux-text-tiny ux-text-tiny--bold" }, h("slot", { key: '41f6e46f0c17dff5c68031682295eae4bf7c34e3' }))));
    }
    static get is() { return "ux-info-banner"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["info-banner.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["info-banner.css"]
        };
    }
    static get properties() {
        return {
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"info\" | \"error\"",
                    "resolved": "\"error\" | \"info\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "banner type: info is for info and partial failure, error for full failure"
                },
                "attribute": "type",
                "reflect": true,
                "defaultValue": "\"info\""
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "icon that should be used in the banner"
                },
                "attribute": "icon",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=info-banner.js.map
